import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const ContactDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	const wcagLabel = t('loading.wcag.processing', {
		namespace: LocalizeNameSpaceTypes.Global,
	});

	return (
		<LayoutGap
			gap="m"
			className="p-6">
			<div className="flex flex-row justify-between">
				<div>
					<GovSkeleton
						width="160px"
						height="32px"
						aria-label={wcagLabel}
					/>
				</div>
				<GovSkeleton
					width="60px"
					height="24px"
					aria-label={wcagLabel}
				/>
			</div>
			<GovSkeleton
				width="260px"
				height="24px"
				aria-label={wcagLabel}
			/>
		</LayoutGap>
	);
};

export const ContactListSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	const wcagLabel = t('loading.wcag.processing', {
		namespace: LocalizeNameSpaceTypes.Global,
	});

	return (
		<LayoutGap gap="l">
			{Array.from({ length: 2 }).map(() => (
				<div>
					<GovSkeleton
						width="180px"
						height="32px"
						aria-label={wcagLabel}
					/>
					{Array.from({ length: 2 }).map(() => (
						<ContactDetailSkeleton />
					))}
					<GovSkeleton
						width="260px"
						height="48px"
						aria-label={wcagLabel}
					/>
				</div>
			))}
		</LayoutGap>
	);
};
